import '@fontsource-variable/lora';
import '@fontsource-variable/lora/wght-italic.css';
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { initOpenCSN } from './opencsn-core';
import { ThemedBackground } from './components/background/ThemedBackground';

function OpenCSNApp() {
  useEffect(() => {
    initOpenCSN();
  }, []);

  return (
    <>
      {/* FULL-PAGE ANIMATED WEBGL GRADIENT BACKGROUND */}
      <ThemedBackground />

      {/* MAIN APPLICATION CONTAINER */}
      <div id="app" className="min-h-screen flex flex-col relative z-[1]" />

      {/* MODAL ROOT */}
      <div id="modal-root" />

      {/* TOAST NOTIFICATION ROOT */}
      <div
        id="toast-root"
        className="fixed bottom-5 right-5 z-50 space-y-2 pointer-events-none"
      />
    </>
  );
}

const rootElement = document.getElementById('root');
if (rootElement) {
  document.getElementById('seo-fallback')?.remove();
  createRoot(rootElement).render(<OpenCSNApp />);
}
